import Image from "next/image";
import { useEffect, useState } from "react";

const ProjectMaintenanceCard = (properties) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false);
  const {
    leftText,
    rightText,
    rightNumber,
    leftNumber,
    index,
    length,
    hidden,
  } = properties;
  useEffect(() => {
    if (window.innerWidth < 767) {
      setIsMobile(true);
    } else if (window.innerWidth < 1080) {
      setIsTab(true);
    } else {
      setIsMobile(false);
      setIsTab(false);
    }
  }, []);

  return (
    <div
      style={
        isMobile || isTab
          ? undefined
          : { marginLeft: `${index > 0 ? 140 * index : 0}px` }
      }
    >
      <div>
        <div className="flex flex-col xl:flex-row items-center">
          <div className="rounded-2xl pt-5 pl-6 w-72 h-40 xl:w-72 xl:h-40 md:w-[26rem] md:h-52 border-2 border-dashed border-white/40">
            <h2 className="font-medium text-4xl md:text-7xl lg:text-4xl lg:leading-tight text-white/15">
              <span>{leftNumber}</span>
            </h2>
            <p className="text-lg md:text-xl font-medium text-white">
              <span dangerouslySetInnerHTML={{ __html: leftText }}></span>
            </p>
          </div>
          {!hidden && (
            <>
              <div className="flex justify-center my-6 mx-auto xl:my-0 xl:mx-4 rotate-90 xl:rotate-0 [&_span]:!overflow-visible [&_span]:!w-auto [&_span]:!h-auto [&_span_img]:!w-9 [&_span_img]:!h-auto [&_span_img]:!max-w-fit [&_span_img]:!relative">
                <Image
                  alt="arrow"
                  height={35}
                  layout="fixed"
                  src={"/assets/common/right-arrow-white-sort.webp"}
                  width={35}
                />
              </div>
              <div className="rounded-2xl pt-5 pl-6 w-72 h-40 xl:w-72 xl:h-40 md:w-[26rem] md:h-52 border-2 border-dashed border-white/40">
                <h2 className="font-medium text-4xl md:text-7xl lg:text-4xl lg:leading-tight text-white/15">
                  <span>{rightNumber}</span>
                </h2>
                <p className="text-lg md:text-xl font-medium text-white">
                  <span dangerouslySetInnerHTML={{ __html: rightText }}></span>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
      {length !== index + 1 && (
        <div className="my-4 mx-auto flex justify-center xl:justify-start xl:my-4 xl:ml-96 [&_span]:!overflow-visible [&_span]:!w-auto [&_span]:!h-auto [&_span_img]:!w-auto [&_span_img]:!h-9 [&_span_img]:!max-w-fit [&_span_img]:!relative">
          <Image
            alt="arrow"
            height={35}
            layout="fixed"
            src={"/assets/common/down-arrow-white-sort.webp"}
            width={35}
          />
        </div>
      )}
    </div>
  );
};

export default ProjectMaintenanceCard;
